export enum Difficulty {
  Easy = 'Easy',
  Normal = 'Normal',
  Hard = 'Hard',
  Extreme = 'Extreme',
  None = 'None',
}
